import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_6: FaireProductEntity = {
  token: "driftless-studios-6",
  type: "product",
  name: "20 oz Pickleball With Double Paddles - Pickleball Gift",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/6c0633e55740c5d2c46bce7027772bcb6b3533fc7dcd2b9aeacb78b942bcbf6f.png?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 16.5,
  msrpDollars: 28,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
